import * as Types from '../constants/Types';

export const getListMarkupBundles = (filters) => ({ type: Types.MARKUP_BUNDLE_LIST_ACTION, filters });
export const setListMarkupBundle = (markupBundle) => ({ type: Types.MARKUP_BUNDLE_LIST_SUCCESS, markupBundle});

export const getMarkupBundleDetail = (id) => ({ type: Types.MARKUP_BUNDLE_DETAIL_ACTION, id });
export const setMarkupBundleDetail = (markupBundle) => ({ type: Types.MARKUP_BUNDLE_DETAIL_SUCCESS, markupBundle });
export const updateMarkupBundleDetail = (markupBundle) => ({ type: Types.MARKUP_BUNDLE_DETAIL_UPDATE_ACTION, markupBundle });
export const createMarkupBundleDetail = (markupBundle) => ({ type: Types.MARKUP_BUNDLE_DETAIL_CREATE_ACTION, markupBundle });
export const deleteMarkupBundleDetail = (markupBundle, filters) => ({ type: Types.MARKUP_BUNDLE_DETAIL_DELETE_ACTION, markupBundle, filters });


